import { GetAdminPermissionsForUserResponse } from '@cbinsights/adminpermissionservice/adminpermissionservice';
import { getSectionPage } from 'client/utils/permissions-validation/hooks/UseGetAdminPermissionsForUserQuery';
import { CbiEntityRoutes } from '../../RoutesHelpers';
import {
  CBI_ENTITY_SECTION_ID,
  CbiEntityTabPathType,
  ENTITY_ADMIN_PERMISSIONS,
} from '../../permissions/EntityAdmin';

// External Mappings has no permission section of its own, it follows General Info's.
// Drafts have no CBI entity id yet, so there is nothing to map.
export const mapExternalMappingsTab = (
  permissions: GetAdminPermissionsForUserResponse,
  isDraftId: boolean
): {
  tab: string;
  key: CbiEntityTabPathType;
  disabled: boolean;
  hasPendingDraft: boolean;
} => ({
  tab: 'External Mappings',
  key: CbiEntityRoutes.ExternalMappings,
  disabled:
    !getSectionPage(
      permissions,
      ENTITY_ADMIN_PERMISSIONS.pageId,
      CBI_ENTITY_SECTION_ID.GeneralInfo
    )?.permissionTypes?.length || isDraftId,
  hasPendingDraft: false,
});
